import {
  createFileRoute,
  linkOptions,
  redirect,
} from '@tanstack/react-router';

const settingsRequestLinkOptions = linkOptions({
  to: '/mydigitalworkers/scout/settings/users',
  from: '/mydigitalworkers/scout/settings/',
});
export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings/',
)({
  beforeLoad: () => {
    throw redirect(settingsRequestLinkOptions);
  },
  component: RouteComponent,
});
function RouteComponent() {
  return (<></>);
}
